import { debounce } from '../../utils/lodash-replacements';
import ScrollCarousel, { measureSlidesPerView } from '../../components/ScrollCarousel';

const SELECTORS = {
  viewport: '[data-cms-related-content-viewport]',
  track: '[data-cms-related-content-track]',
};

const sliders = [];

const destroySliders = () => {
  sliders.forEach((slider) => {
    slider.destroy();
  });
  sliders.length = 0;
};

const handleSlider = debounce(() => {
  if (sliders.length > 0) {
    destroySliders();
  }
  document.querySelectorAll('[data-cms-related-content-slider]').forEach((slider) => {
    const tiles = slider.querySelectorAll('[data-slider-tile]');
    if (tiles.length === 0) {
      return;
    }
    const tile_width = tiles[0].offsetWidth;
    const window_width = window.innerWidth;
    // Nothing overflows, so there is nothing to slide to.
    if (tiles.length * tile_width < window_width) {
      return;
    }

    const viewport = slider.querySelector(SELECTORS.viewport);
    if (!viewport) {
      return;
    }

    const carousel = new ScrollCarousel(slider, {
      selectors: SELECTORS,
      // Flickity `wrapAround: true`. `arrowShape` is dropped — the arrows are
      // drawn in SCSS now, not from an injected SVG path.
      loop: true,
      prevNextButtons: true,
      pageDots: true,
      draggable: true,
      // Several tiles are on screen at once, so the loop must clone a full
      // viewport's worth or the seam shows a gap.
      slidesPerView: measureSlidesPerView(viewport, tiles[0]),
      ariaLabel: 'Related content slider',
    });
    sliders.push(carousel);
  });
}, 250);

const initSlider = () => {
  window.addEventListener('resize', () => handleSlider());
};

export { destroySliders, initSlider };
